// Solarized color palette
export const colors = {
  // Light mode (active)
  base3: "#FDF6E3", // lightest bg
  base2: "#EEE8D5", // light bg highlights
  base1: "#93A1A1", // optional emphasized content
  base0: "#839496", // body text

  // Dark mode (idle/sleep)
  base03: "#002B36", // darkest bg
  base02: "#073642", // dark bg highlights
  base01: "#586E75", // comments
  base00: "#657B83", // body text dark

  // Accent colors
  yellow: "#B58900",
  orange: "#CB4B16",
  red: "#DC322F",
  magenta: "#D33682",
  violet: "#6C71C4",
  blue: "#268BD2",
  cyan: "#2AA198",
  green: "#859900",
} as const;

export type Colors = typeof colors;

// Shared types
export interface Node {
  id: number;
  row: number;
  col: number;
  x: number;
  y: number;
}

export interface GridConfig {
  cols: number;
  rows: number;
  startX: number;
  startY: number;
}
